import { Pipe, PipeTransform } from '@angular/core';
import { AccountingPlanModel } from 'models/generated/Entities.Accounting.AccountingPlan';
import { TranslatePipe } from 'pipes/translate.pipe';
import { DateService } from 'services/date.service';

@Pipe({
	name: 'paymentInterval'
})

export class PaymentIntervalPipe implements PipeTransform {

	constructor(private readonly translate: TranslatePipe, private readonly dateService: DateService) { }

	transform(interval: number | undefined, variables?: { installments?: number; accountingPlan?: AccountingPlanModel; }): string {
		if (interval && variables?.installments && variables.installments > 1) return this.translate.transform('payment-interval.installments-and-interval', { interval: interval.toString(), installments: variables.installments.toString() });
		if (!interval || variables?.installments == 1 || (variables?.accountingPlan?.startDate && this.dateService.getDiffInMonths(variables?.accountingPlan?.startDate, variables?.accountingPlan?.endDate!) <= interval)) return this.translate.transform('payment-interval.full-payment');
		if (interval == 1) return this.translate.transform('payment-interval.monthly');
		if (interval == 3) return this.translate.transform('payment-interval.quarterly');
		if (interval == 6) return this.translate.transform('payment-interval.semi-annually');
		if (interval == 12) return this.translate.transform('payment-interval.annually');
		return this.translate.transform('payment-interval.interval', { interval: interval.toString() });
	}
}
